import { Component, effect, ElementRef, viewChild } from '@angular/core';

@Component({
  selector: 'app-video-loader',
  standalone: true,
  imports: [
    
  ],
  templateUrl: './video-loader.component.html',
  styleUrls: ['./video-loader.component.scss'],
})
export class VideoLoaderComponent {
  public videoRef = viewChild<ElementRef<HTMLVideoElement>>('videoRef');
  
  playVideo = effect(() => {
    const videoRef = this.videoRef();
    if (!videoRef) return;
    
    const videoEl = videoRef.nativeElement;
    videoEl.muted = true;
    videoEl.playsInline = true;
    
    const playPromise = videoEl.play();
    if (playPromise !== undefined) {
      playPromise.then(_ => {

      })
      .catch(error => {
        console.error('Error attempting to play', error);
      });
    }
  }, { allowSignalWrites: true });
}
